module.exports = new __parcel__URL__("crown.5a3798ea.webp").toString();